import { render, staticRenderFns } from "./ManualPlanningVehicleGroupReg.vue?vue&type=template&id=2197f158"
import script from "./ManualPlanningVehicleGroupReg.vue?vue&type=script&lang=js"
export * from "./ManualPlanningVehicleGroupReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports